import { TaggedError } from "@for-it/domain-lib";
export class CertificationUserNotFoundError extends TaggedError {
    constructor() {
        super("CertificationUserNotFoundError");
    }
}
